import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var MessageTemplateService = /** @class */ (function (_super) {
    tslib_1.__extends(MessageTemplateService, _super);
    function MessageTemplateService(http) {
        var _this = _super.call(this, http, MapperService.messageTemplateMap) || this;
        _this._endpoint = 'odata/MessageTemplates';
        return _this;
    }
    MessageTemplateService.prototype.getTemplate = function (template) {
        return this.get({
            filter: {
                'Name': template,
            },
        }).pipe(map(function (result) {
            var found = result.data[0];
            return found;
        }));
    };
    return MessageTemplateService;
}(ODataService));
export { MessageTemplateService };
